module.exports = __webpack_public_path__ + "img/clip3.189e8013.svg";